export class JyWarehouseConstants {
  constructor(code, englishName, chineseName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

// 放货状态
export const RELEASE_GOODS_EMPTY = new JyWarehouseConstants(0, '', '')
export const RELEASE_GOODS_NOTIFIED = new JyWarehouseConstants(1, 'Notified', '已通知')
export const RELEASE_GOODS_OUT = new JyWarehouseConstants(2, 'Released Goods', '已放货')
export const RELEASE_STATE = new Set([RELEASE_GOODS_EMPTY, RELEASE_GOODS_NOTIFIED, RELEASE_GOODS_OUT])

export function getNameByCode(code, list) {
  for (var item of list) {
    if (item.code === code) {
      return item
    }
  }
  return null
}
